/*
 * GameStartScreen
 * ==========
 */
import ScreenBase from '../ui/ScreenBase'

export default class GameStartScreen extends ScreenBase {

    constructor(game, screens) {
        super(game, 'gameStart');
        window.gss = this;
        this.screens = screens;

        this.params = {
            'bg': [0, 0],
            'logo': [0, -89],
            'instruction': [0, 0],
            'play': [0, 95],
            'help': [-116, 95],
            'mute': [115, 96],
            'unmute': [115, 96]
        };

        this.bg = this.addSprite('bg', 'uiScreens', 'uiGameStartPanel.png');
        this.logo = this.addSprite('logo', 'uiScreens', 'uiLogo.png');
        this.instruction = this.addText2('instruction', 'blue',
            'Join adjacent letters to create words.\nClear as many lines as you can\nbefore the time runs out!', 18);

        this.play = this.addTextButton2('play', 'uiButtonContinue', 'Play', this.playClicked);
        this.help = this.addButton('help', 'helpButton', this.helpClicked);

        this.buttonMute = this.addButton('mute', 'unmuteButton', this.unmuteClicked);
        this.buttonUnmute = this.addButton('unmute', 'muteButton', this.muteClicked);

        this.setInputForAllButtons(false);
    }

    onShowEnded() {
        super.onShowEnded();
        this.updateMuteButtons();
    }

    playClicked(that) {
        AUDIO.playMusic();
        ARK_game_arena_connector.fireEventToArena('game_start');
        that.forceOutForAllButtons();
        that.screens.showScreen('levelStart');
    }

    helpClicked(that) {
        GS.overlayScreens.screenBeforeHelp = 'gameStart';
        GS.overlayScreens.showScreen('help1');
    }

    muteClicked(that) {
        GS.mute();
    }

    unmuteClicked(that) {
        GS.unmute();
    }

    updateMuteButtons() {
        if (AUDIO.allMuted) {
            this.buttonMute.alpha = 1;
            this.buttonUnmute.alpha = 0;
            this.buttonMute.inputEnabled = true;
            this.buttonUnmute.inputEnabled = false;
        } else {
            this.buttonMute.alpha = 0;
            this.buttonUnmute.alpha = 1;
            this.buttonMute.inputEnabled = false;
            this.buttonUnmute.inputEnabled = true;
        }
    }
}
